import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface DialogSecondaryAction {
  label: string;
  onClick: () => void;
}

export interface Confirmation {
  title: string;
  message: string;

  acceptLabel?: string;
  rejectLabel?: string;
  acceptButtonType?: 'primary' | 'secondary' | 'red';
  rejectButtonType?: string;
  hasSuccessGraphic?: boolean;
  graphicUrl?: string;
  noteInputLabel?: string;

  /** Optional secondary content box rendered between the message and the buttons. */
  secondaryTitle?: string;
  secondaryMessage?: string;

  /** Optional extra button rendered alongside accept/reject, e.g. a feature-specific shortcut action. */
  secondaryAction?: DialogSecondaryAction;
}

const defaults: Partial<Confirmation> = {
  acceptLabel: 'OK',
  rejectLabel: 'Cancel',
  acceptButtonType: 'red',
  rejectButtonType: 'secondary',
  hasSuccessGraphic: false
};

@Injectable({ providedIn: 'root' })
export class DialogService {
  public confirmation: Confirmation;
  public isAcceptButtonLoading = false;
  public noteValue = '';

  private resolve: (value: any) => void;

  constructor(private router: Router) {}

  public async confirm(confirmation: Confirmation): Promise<boolean> {
    this.confirmation = { ...defaults, ...confirmation };
    this.isAcceptButtonLoading = false;
    this.noteValue = '';

    const result = await new Promise<boolean>((resolve) => (this.resolve = resolve));
    this.confirmation = undefined;

    return result;
  }

  public async confirmAndDo(confirmation: Confirmation, action: () => Promise<void>): Promise<boolean> {
    this.confirmation = { ...defaults, ...confirmation };
    this.isAcceptButtonLoading = false;
    this.noteValue = '';

    const result = await new Promise<boolean>((resolve) => (this.resolve = resolve));

    if (!result) {
      this.confirmation = undefined;
      return;
    }

    this.isAcceptButtonLoading = true;

    await action();

    this.confirmation = undefined;
    this.isAcceptButtonLoading = false;
  }

  public accept() {
    this.resolve && this.resolve(true);
    this.resolve = undefined;
  }

  public reject() {
    this.resolve && this.resolve(false);
    this.resolve = undefined;
  }

  public action(url: string) {
    this.resolve && this.resolve(true);
    this.resolve = undefined;

    this.router.navigate([url]).catch((error) => {
      console.error('Navigation failed:', error);
    });
  }
}
